const animations: AnimationProps = {
  durationDefault: 0.25,
  durationSlow: 0.5,
  durationFast: 0.15,
  timingFunction: 'ease-out',
  get default() {
    return `${this.durationDefault}s ${this.timingFunction}`;
  },
  get slow() {
    return `${this.durationSlow}s ${this.timingFunction}`;
  },
  get fast() {
    return `${this.durationFast}s ${this.timingFunction}`;
  },
};

export interface AnimationProps {
  [key: string]: any;
}

export default animations;
